import React, { useState } from 'react';
import { getImageURL } from '../utils/api';

export function initialsFromName(name) {
  if (!name) return '?';
  return name.trim().split(/\s+/).filter(Boolean).map((w) => w[0]).slice(0, 2).join('').toUpperCase();
}

export default function Avatar({ name, imagePath, size = 'h-8 w-8' }) {
  const [imageError, setImageError] = useState(false);

  if (imagePath && !imageError) {
    return (
      <img
        src={getImageURL(imagePath)}
        alt={name || 'Avatar'}
        onError={() => setImageError(true)}
        className={`${size} shrink-0 rounded-full object-cover`}
      />
    );
  }

  return (
    <div className={`flex ${size} shrink-0 items-center justify-center rounded-full bg-indigo-100 text-xs font-bold text-indigo-700`}>
      {initialsFromName(name)}
    </div>
  );
}
